import 'request';

import RPC from 'RPC';

import './RPCInject';

RPC.setup({
    version: 1,
    baseUrl: window.location.origin + '/api/',
    timeout: 35000,
    htmlencoded: undefined,
});
